import React from 'react';

function ResponsePage({title, description, button}) {
    return (
        <div className="form-container response-page">
            <div className="check-img">
                <img src="/Images/check.png" alt=""/>
            </div>
            <div className="res-title">{title}</div>
            <div className="description">{description}</div>

            {
                button &&
                <div className="btn-container">
                    <button className="continue-btn" onClick={()=>{
                        window.location.href = "/merchantinformation"
                    }}>Done</button>
                </div>
            }

        </div>
    );
}

export default ResponsePage;